import HTTP from "@/_helpers/http";
import { CONTEST__API } from "@/_helpers/urls";
import { CONTEST__MUTATIONS } from "../mutation-types";
import { CONTEST__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
    viewcontest: null,
    allcontests: [],
    allupcomingcontests: [],
    allrunningcontests: [],
    allfinishedcontests: [],
    allacctypes: [],
    finishedcontest: null,
    runningcontest: null,
    upcomingcontest: null,
    approvedparticipants: [],
    pendingparticipants: [],
    allfinishedparticipants: [],
    allrunningparticipants: [],
    allupcomingparticipants: [],
};

//Getters
const getters = {};

//Mutations
const mutations = {
    [CONTEST__MUTATIONS.GETALLFINISHEDCONTEST](state, data) {
        state.allfinishedcontests = data;
    },
    [CONTEST__MUTATIONS.GETALLRUNNINGCONTEST](state, data) {
        state.allrunningcontests = data;
    },
    [CONTEST__MUTATIONS.GETALLUPCOMINGCONTEST](state, data) {
        state.allupcomingcontests = data;
    },
    [CONTEST__MUTATIONS.GETALLCONTEST](state, data) {
        state.allcontests = data;
    },
    [CONTEST__MUTATIONS.GETALLCONTESTACCTYPES](state, data) {
        state.allacctypes = data;
    },
    [CONTEST__MUTATIONS.GETCONTEST](state, data) {
        state.viewcontest = data;
    },
    [CONTEST__MUTATIONS.VIEWFINISHEDCONTEST](state, data) {
        state.finishedcontest = data;
    },
    [CONTEST__MUTATIONS.VIEWRUNNINGCONTEST](state, data) {
        state.runningcontest = data;
    },
    [CONTEST__MUTATIONS.VIEWUPCOMINGCONTEST](state, data) {
        state.upcomingcontest = data;
    },
    [CONTEST__MUTATIONS.APPROVEDPARTICIPANTS](state, data) {
        state.approvedparticipants = data;
    },
    [CONTEST__MUTATIONS.PENDINGPARTICIPANTS](state, data) {
        state.pendingparticipants = data;
    },
    [CONTEST__MUTATIONS.ALLFINISHEDPARTICIPANTS](state, data) {
        state.allfinishedparticipants = data;
    },
    [CONTEST__MUTATIONS.ALLRUNNINGPARTICIPANTS](state, data) {
        state.allrunningparticipants = data;
    },
    [CONTEST__MUTATIONS.ALLUPCOMINGPARTICIPANTS](state, data) {
        state.allupcomingparticipants = data;
    },
};

// Actions
const actions = {
    async [CONTEST__ACTIONS.CREATECONTEST]({ dispatch }, data) {
        try {
            const url = `${CONTEST__API.CREATECONTEST}`;
            const response = await HTTP().post(url, data);

            if (response.status === 200) {
                await dispatch(CONTEST__ACTIONS.ALLFINISHEDPARTICIPANTS);
                await dispatch(CONTEST__ACTIONS.ALLRUNNINGPARTICIPANTS);
                await dispatch(CONTEST__ACTIONS.ALLUPCOMINGPARTICIPANTS);
                await dispatch(CONTEST__ACTIONS.GETALLFINISHEDCONTEST);
                await dispatch(CONTEST__ACTIONS.GETALLRUNNINGCONTEST);
                await dispatch(CONTEST__ACTIONS.GETALLUPCOMINGCONTEST);
                return { success: true };
            }
            return { success: false };
        } catch (error) {
            console.log(error);
            toast.error("Failed to create contest")
            return { success: false };
        }
    },
    async [CONTEST__ACTIONS.UPDATECONTEST]({ dispatch }, data) {
        try {
            const url = `${CONTEST__API.UPDATECONTEST}`;
            const response = await HTTP().post(url, data);

            if (response.status === 200) {
                await dispatch(CONTEST__ACTIONS.GETCONTEST, data.id);
                await dispatch(CONTEST__ACTIONS.ALLFINISHEDPARTICIPANTS);
                await dispatch(CONTEST__ACTIONS.ALLRUNNINGPARTICIPANTS);
                await dispatch(CONTEST__ACTIONS.ALLUPCOMINGPARTICIPANTS);
                await dispatch(CONTEST__ACTIONS.GETALLFINISHEDCONTEST);
                await dispatch(CONTEST__ACTIONS.GETALLRUNNINGCONTEST);
                await dispatch(CONTEST__ACTIONS.GETALLUPCOMINGCONTEST);
                await dispatch(CONTEST__ACTIONS.GETALLCONTEST);
                return { success: true };
            }
            return { success: false };
        } catch (error) {
            console.log(error);
            toast.error("Failed to update contest")
            return { success: false };
        }
    },
    async [CONTEST__ACTIONS.UPDATECONTESTANTSTATUS]({ dispatch }, data) {
        try {
            const url = `${CONTEST__API.UPDATECONTESTANTSTATUS}`;
            const response = await HTTP().post(url, data);

            if (response.status === 200) {
                await dispatch(CONTEST__ACTIONS.ALLFINISHEDPARTICIPANTS);
                await dispatch(CONTEST__ACTIONS.ALLRUNNINGPARTICIPANTS);
                await dispatch(CONTEST__ACTIONS.ALLUPCOMINGPARTICIPANTS);
                await dispatch(CONTEST__ACTIONS.GETALLFINISHEDCONTEST);
                await dispatch(CONTEST__ACTIONS.GETALLRUNNINGCONTEST);
                await dispatch(CONTEST__ACTIONS.GETALLUPCOMINGCONTEST);
                toast.success("Update Successfully")
            }
            return { success: false };
        } catch (error) {
            console.log(error);
            toast.error("Failed to update contest")
            return { success: false };
        }
    },
    async [CONTEST__ACTIONS.GETALLCONTESTACCTYPES]({ commit, state }) {
        try {
            const url = `${CONTEST__API.GETALLCONTESTACCTYPES}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(CONTEST__MUTATIONS.GETALLCONTESTACCTYPES, response.data);
            } else {
                commit(CONTEST__MUTATIONS.GETALLCONTESTACCTYPES, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [CONTEST__ACTIONS.ALLFINISHEDPARTICIPANTS]({ commit, state }, parameter) {
        try {
            const statusParam = parameter?.status != null ? `status=${parameter.status}` : "";
            const idParam = parameter?.contest_id != null ? `contest_id=${parameter.contest_id}` : "";
            const timeParam = parameter?.duration != null ? `duration=${parameter.duration}` : "";

            const parameterString = [
                statusParam,
                idParam,
                timeParam
            ]
                .filter((param) => param !== "")
                .join("&");

            const response = await HTTP().get(
                CONTEST__API.ALLFINISHEDPARTICIPANTS +
                (parameterString !== "" ? `?${parameterString}` : "")
            );

            if (response.status === 200) {
                commit(CONTEST__MUTATIONS.ALLFINISHEDPARTICIPANTS, response.data);
            } else {
                commit(CONTEST__MUTATIONS.ALLFINISHEDPARTICIPANTS, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [CONTEST__ACTIONS.ALLRUNNINGPARTICIPANTS]({ commit, state }, parameter) {
        try {
            const statusParam = parameter?.status != null ? `status=${parameter.status}` : "";
            const idParam = parameter?.contest_id != null ? `contest_id=${parameter.contest_id}` : "";
            const timeParam = parameter?.duration != null ? `duration=${parameter.duration}` : "";

            const parameterString = [
                statusParam,
                idParam,
                timeParam
            ]
                .filter((param) => param !== "")
                .join("&");

            const response = await HTTP().get(
                CONTEST__API.ALLRUNNINGPARTICIPANTS +
                (parameterString !== "" ? `?${parameterString}` : "")
            );

            if (response.status === 200) {
                commit(CONTEST__MUTATIONS.ALLRUNNINGPARTICIPANTS, response.data);
            } else {
                commit(CONTEST__MUTATIONS.ALLRUNNINGPARTICIPANTS, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [CONTEST__ACTIONS.ALLUPCOMINGPARTICIPANTS]({ commit, state }, parameter) {
        try {
            const statusParam = parameter?.status != null ? `status=${parameter.status}` : "";
            const idParam = parameter?.contest_id != null ? `contest_id=${parameter.contest_id}` : "";
            const timeParam = parameter?.duration != null ? `duration=${parameter.duration}` : "";

            const parameterString = [
                statusParam,
                idParam,
                timeParam
            ]
                .filter((param) => param !== "")
                .join("&");

            const response = await HTTP().get(
                CONTEST__API.ALLUPCOMINGPARTICIPANTS +
                (parameterString !== "" ? `?${parameterString}` : "")
            );

            if (response.status === 200) {
                commit(CONTEST__MUTATIONS.ALLUPCOMINGPARTICIPANTS, response.data);
            } else {
                commit(CONTEST__MUTATIONS.ALLUPCOMINGPARTICIPANTS, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [CONTEST__ACTIONS.GETCONTEST]({ commit, state }, id) {
        try {
            const url = `${CONTEST__API.GETCONTEST}`;
            const response = await HTTP().get(`${url}/${id}`);

            if (response.status === 200) {
                commit(CONTEST__MUTATIONS.GETCONTEST, response.data);
            } else {
                commit(CONTEST__MUTATIONS.GETCONTEST, null);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [CONTEST__ACTIONS.GETALLCONTEST]({ commit, state }) {
        try {
            const url = `${CONTEST__API.GETALLCONTEST}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(CONTEST__MUTATIONS.GETALLCONTEST, response.data);
            } else {
                commit(CONTEST__MUTATIONS.GETALLCONTEST, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [CONTEST__ACTIONS.APPROVEDPARTICIPANTS]({ commit, state }) {
        try {
            const url = `${CONTEST__API.APPROVEDPARTICIPANTS}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(CONTEST__MUTATIONS.APPROVEDPARTICIPANTS, response.data);
            } else {
                commit(CONTEST__MUTATIONS.APPROVEDPARTICIPANTS, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [CONTEST__ACTIONS.PENDINGPARTICIPANTS]({ commit, state }, id) {
        try {
            const url = `${CONTEST__API.PENDINGPARTICIPANTS}/${id}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(CONTEST__MUTATIONS.PENDINGPARTICIPANTS, response.data);
            } else {
                commit(CONTEST__MUTATIONS.PENDINGPARTICIPANTS, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [CONTEST__ACTIONS.GETALLFINISHEDCONTEST]({ commit, state }) {
        try {
            const url = `${CONTEST__API.GETALLFINISHEDCONTEST}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(CONTEST__MUTATIONS.GETALLFINISHEDCONTEST, response.data);
            } else {
                commit(CONTEST__MUTATIONS.GETALLFINISHEDCONTEST, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [CONTEST__ACTIONS.VIEWFINISHEDCONTEST]({ commit, state }, id) {
        try {
            const url = `${CONTEST__API.VIEWFINISHEDCONTEST}/${id}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(CONTEST__MUTATIONS.VIEWFINISHEDCONTEST, response.data);
            } else {
                commit(CONTEST__MUTATIONS.VIEWFINISHEDCONTEST, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [CONTEST__ACTIONS.VIEWRUNNINGCONTEST]({ commit, state }, id) {
        try {
            const url = `${CONTEST__API.VIEWRUNNINGCONTEST}/${id}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(CONTEST__MUTATIONS.VIEWRUNNINGCONTEST, response.data);
            } else {
                commit(CONTEST__MUTATIONS.VIEWRUNNINGCONTEST, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [CONTEST__ACTIONS.VIEWUPCOMINGCONTEST]({ commit, state }, id) {
        try {
            const url = `${CONTEST__API.VIEWUPCOMINGCONTEST}/${id}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(CONTEST__MUTATIONS.VIEWUPCOMINGCONTEST, response.data);
            } else {
                commit(CONTEST__MUTATIONS.VIEWUPCOMINGCONTEST, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [CONTEST__ACTIONS.GETALLRUNNINGCONTEST]({ commit, state }) {
        try {
            const url = `${CONTEST__API.GETALLRUNNINGCONTEST}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(CONTEST__MUTATIONS.GETALLRUNNINGCONTEST, response.data);
            } else {
                commit(CONTEST__MUTATIONS.GETALLRUNNINGCONTEST, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [CONTEST__ACTIONS.GETALLUPCOMINGCONTEST]({ commit, state }) {
        try {
            const url = `${CONTEST__API.GETALLUPCOMINGCONTEST}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(CONTEST__MUTATIONS.GETALLUPCOMINGCONTEST, response.data);
            } else {
                commit(CONTEST__MUTATIONS.GETALLUPCOMINGCONTEST, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};
